import { camelToDash } from "../../render/dom/utils/camel-to-dash";
export const optimizedAppearDataId = "framerAppearId";
export const optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);
//# sourceMappingURL=data-id.js.map